// locale for fish

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('fish_locale');
module.exports = locale;
